import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";
import { SubscriptionContractSubscriptionStatus } from "@smartrr/shared/shopifyGraphQL/api";
import { useMemo } from "react";

import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

import { useSortedPurchaseStates } from "../useSortedPurchaseStates";

export const usePurchaseStates = () => {
  return useSmartrrCustomerSelector(state => state.purchaseStates.purchaseStates);
};

export const useFirstPurchaseStateToDisplay = (upcomingDelivery: PurchaseStateAndDelivery) => {
  // TODO: Repro error when cancelling first cps
  const sortedPurchaseStates = useSortedPurchaseStates();
  const delivery = useMemo(() => {
    /**
     * Finding the first purchaseState to display:
     * 1. Find cps that matches with upcomingDelivery id and not paused
     * 2. If upcoming cps is paused, then finding a cps that isn't paused
     * 3. If all cps' are paused, display first available cps
     */
    if (upcomingDelivery) {
      return (
        sortedPurchaseStates.find(([_, purchaseStates]) =>
          purchaseStates.some(
            cps =>
              cps.id === upcomingDelivery.purchaseState.id &&
              cps.purchaseStateStatus !== SubscriptionContractSubscriptionStatus.Paused
          )
        ) ??
        sortedPurchaseStates.find(([_, purchaseStates]) =>
          purchaseStates.some(cps => cps.purchaseStateStatus !== SubscriptionContractSubscriptionStatus.Paused)
        ) ??
        sortedPurchaseStates[0]
      );
    }
    return sortedPurchaseStates[0];
  }, [sortedPurchaseStates, upcomingDelivery]);

  return { delivery, sortedPurchaseStates };
};
